<div class="main">
    <div>
        <mat-progress-spinner mode="indeterminate" [color]="color" diameter="150"></mat-progress-spinner>
        <div style="margin-top: 10px; font-size: 24px; font-weight:600;">Data Loading, Please Wait...</div>
    </div>
</div>